/* eslint-disable */
import store from "../../store/index";
import axios from "axios";

export default {
    name: "SDVOutcomesModal",
    props: {
        sdvId: {
            type: String,
            default: "",
        },
        activitystatusreload: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            idToken: "",
            headerValues: "",
            baseapi: process.env.VUE_APP_Service_URL,
            sdvOutcomesList: [],
            sdvOutcome: "",
            comments: "",
            loadingBlock: false,
        };
    },
    async mounted() {
        this.idToken = store.getters.getIdToken;
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };
        await this.fetchSDVOutcomes();
    },
    methods: {
        async fetchSDVOutcomes() {
            try {
                const res = await axios.get(
                    `${this.baseapi}/management/statusmaster/getall?StatusType=SDVStatus`,
                    this.headerValues
                );
                this.sdvOutcomesList = res.data;
            } catch (err) {
                console.log("Error fetching SDV outcomes", err);
            }
        },
        async saveSDVOutcome() {
            if (!this.sdvOutcome) {
                alert("Please select an SDV outcome.");
                return;
            }
            this.loadingBlock = true;
            try {
                await axios.put(
                    `${this.baseapi}/forms/rbqm/updatesdv`,
                    {
                        signalId:this.sdvId,
                        sdvVerificationComments: this.comments,
                        sdvStatus: this.sdvOutcome,
                    },
                    this.headerValues
                );
                this.loadingBlock = false;
                alert("SDV verified successfully");
                this.$emit("changeStatus", this.activitystatusreload);
                this.$emit("closeModal");
            } catch (err) {
                console.log("Error saving SDV outcome", err);
                this.loadingBlock = false;
            }
        },
        closemodal() {
            this.$emit("closeModal");
        },
    },
};